// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__188dT","icon":"styles_icon__MCQSE","edit":"styles_edit__3Qt7L","save":"styles_save__1p4hi","input":"styles_input__2DwuC"};